import { format } from 'date-fns';
import dayjs, { Dayjs } from 'dayjs';


function getPreviousMonth(date = new Date()) {
    const previous = new Date(date.getTime());
    previous.setMonth(date.getMonth() - 1);
  
    return previous;
}



export class DateHelper {

    static getPreviousFormattedMonthDate(): String{
        return `${format(getPreviousMonth(), 'yyyy-MM-dd')}T00:00:00`
    }

    static getCurrentFormatedDate(): String {
        return `${format(new Date(), 'yyyy-MM-dd')}T23:59:00`;
    }

    static getDayJsLastMonthRange(): [Dayjs, Dayjs] {
        return [dayjs().subtract(1, 'month'), dayjs().endOf('day')]
    }
}